export const FETCH_ALL_GROUPS = 'FETCH_ALL_GROUPS';
export const FETCH_GROUPS_FOR_PROFILE = 'FETCH_GROUPS_FOR_PROFILE';
export const CREATE_GROUP = 'CREATE_GROUP';
export const GET_GROUP = 'GET_GROUP';
export const JOIN_GROUP = 'JOIN_GROUP';
export const UPDATE_GROUP = 'UPDATE_GROUP';
export const CLEAR_GROUP = 'CLEAR_GROUP';